import { render, staticRenderFns } from "./GestionMapaHidrocarburos.vue?vue&type=template&id=48c81aca&scoped=true"
import script from "./GestionMapaHidrocarburos.vue?vue&type=script&lang=js"
export * from "./GestionMapaHidrocarburos.vue?vue&type=script&lang=js"
import style0 from "./GestionMapaHidrocarburos.vue?vue&type=style&index=0&id=48c81aca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c81aca",
  null
  
)

export default component.exports